import {
  Brain,
  User,
  Heart,
  Users,
  Sparkles,
  Compass,
  Apple,
  Lightbulb,
  ArrowRight,
} from "lucide-react";
import { AREAS } from "../data/content";

const ICONS = {
  Brain,
  User,
  Heart,
  Users,
  Sparkles,
  Compass,
  Apple,
  Lightbulb,
};

export const AreasAtuacao = () => {
  return (
    <section
      id="atuacao"
      data-testid="areas-section"
      className="py-20 md:py-28 bg-gradient-to-br from-secondary/60 via-background to-gold-50/30 border-y-2 border-gold-500/20"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-royal-800/10 border border-royal-800/30">
            <span className="text-[11px] tracking-[0.2em] uppercase text-royal-800 font-semibold">
              Áreas de atuação
            </span>
          </div>
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl text-royal-900 leading-tight">
            Cuidado integral para cada <br /> etapa da vida.
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">
            Abordagens contemporâneas combinadas à vasta experiência clínica — sempre
            personalizadas para o momento e a história de cada pessoa, casal ou família.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {AREAS.map((a, i) => {
            const Icon = ICONS[a.icon] || Sparkles;
            return (
              <a
                key={a.id}
                href="#contato"
                data-testid={`area-card-${a.id}`}
                className="group relative overflow-hidden rounded-xl bg-white border border-border hover:border-royal-800/60 hover:-translate-y-1 hover:shadow-xl hover:shadow-royal-900/10 transition-all duration-300 flex flex-col"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-royal-900/80 via-royal-900/30 to-transparent" />
                  <div className="absolute top-3 left-3 w-10 h-10 rounded-lg bg-white/95 text-royal-800 flex items-center justify-center shadow-md">
                    <Icon size={18} />
                  </div>
                  <h3 className="absolute bottom-3 left-4 right-4 font-serif-display text-xl md:text-2xl text-white leading-tight">
                    {a.title}
                  </h3>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <p className="text-sm text-muted-foreground leading-relaxed flex-1">
                    {a.description}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-xs tracking-wider uppercase text-royal-800 font-semibold group-hover:text-gold-600 transition-colors">
                    Agendar <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
